const makeWorder = (word: string, ending = 'er') => word?.replace(/e?$/, ending) || '';

export default makeWorder;
